import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);
import MicroModal from 'micromodal';

export namespace DistributorContact {
	
	let setupModal = () => {
		let links = document.querySelectorAll('.js-distributor-contacts');

		links.forEach((link) => {
			link.addEventListener('click', (e) => {
				
				MicroModal.show('modal-distributor-links', {
					onShow: function () {
						let leadBtn = document.getElementById('ModalBtnLead');
						if (leadBtn) {
							leadBtn.blur();
						}
					},
				});

				e.preventDefault();
			});
		});
	}

	export const init = () => {
		setupModal();
	}
}


document.addEventListener('DOMContentLoaded', DistributorContact.init);
